/* eslint-disable */
const PAYMENT = {
  TRANSACTION_MASTER_LIST_PAYMENT: 'payment/transaction/master/list',
  TRANSACTION_DETAILS_OF_LIST_PAYMENT: 'payment/transaction/details/of/list'
}
export default PAYMENT
